module.exports = __webpack_public_path__ + "media/assets/faria_products/POWERSCHOOL-0207453be6bc725b841adf5ed5892ec65985f10aaa615c0eeb999f2f2d3a667f.png";